import { ColumnDef } from '@tanstack/react-table';
import { DataTableColumnHeader } from '../../../../components/blocks/data-table/data-table-column-header';
import { GroupDataTableRowActions } from './iam-group-table-action';
import { TruncateTooltip } from 'hooks/use-truncate-tooltip';

export interface GroupData {
    id: string;
    groupName: string;
    groupType: string;
    ownerUserId?: string;
    source?: string;
    users?: any[];
}

interface ColumnFactoryProps {
    onViewDetails?: (group: GroupData) => void;
    onEditGroup?: (group: GroupData) => void;
    onDeleteGroup?: (group: GroupData) => void;
    onManageUsers?: (group: GroupData) => void;
    t: (key: string) => string;
}

export const createGroupTableColumns = ({
    t, onDeleteGroup, onViewDetails, onEditGroup
}: ColumnFactoryProps): ColumnDef<GroupData, any>[] => [
        {
            id: 'groupName',
            accessorFn: (row) => row.groupName,
            header: ({ column }) => <DataTableColumnHeader column={column} title={t('GROUP_NAME')} />,
            cell: ({ row }) => {
                const groupName = row.original.groupName || '-';
                return (
                    <div className="flex items-center">
                        <div className="w-full max-w-[150px] sm:max-w-[250px] md:max-w-[350px] lg:max-w-[450px]">
                            {/* <span className="max-w-full truncate font-medium">{groupName}</span> */}
                            <TruncateTooltip
                                text={groupName}
                                className="max-w-full font-medium"
                            />
                        </div>
                    </div>
                );
            },

        },
        {
            id: 'actions',
            cell: ({ row }) => (
                <GroupDataTableRowActions
                    row={row as any}
                    onDelete={onDeleteGroup as any}
                    isGroupTableAction={true}
                    onViewDetails={onViewDetails as any}
                    onEditGroup={onEditGroup as any}
                />
            ),
        },
    ];